import React, { useEffect, useState } from 'react';
import { Paragraph } from '@project-stories/elements/Paragraph/Paragraph';
import { Button } from '@project-stories/elements/Button/Button';
import './CircleTextSection.css';
import AnimatedPulse from '../AnimatedPulse/AnimatedPulse';

export const CircleTextSection = ({ props }) => {
  const [isMobile, setIsMobile] = useState(false);

  const { settings } = props;
  const globals = settings.globals || {};

  // Configure circle styles based on settings
  const circleSize = isMobile ? settings.section.section.circle_size_mobile || 300 : settings.section.circle_size || 400;
  const circleColor = settings.section.circle_background_color || '#F9F5F0';
  const circleBorder = settings.section.circle_border_enabled ? `${settings.section.circle_border_width || 1}px solid ${settings.section.circle_border_color || '#000'}` : 'none';
  
  // Pulse animation configuration
  const usePulse = settings.section.enable_pulse_animation || false;
  const pulseColor = settings.section.pulse_color || 'rgba(249, 245, 240, 0.4)';
  const pulseSpeed = settings.section.pulse_speed || 2; // in seconds

  // Content alignment and spacing
  const contentGap = settings.section.content_gap || 24;
  const contentPadding = {
    desktop: {
      top: settings.section.padding_top_bottom_desktop || 12,
      bottom: settings.section.padding_top_bottom_desktop || 12,
      left: settings.section.padding_left_right_desktop || 20,
      right: settings.section.padding_left_right_desktop || 20
    },
    mobile: {
      top: settings.section.padding_top_botton_mobile || 20,
      bottom: settings.section.padding_top_botton_mobile || 20,
      left: settings.section.padding_left_right_mobile || 12,
      right: settings.section.padding_left_right_mobile || 12
    }
  };

  // Button configuration
  const showButton = settings.section.show_button || false;
  const buttonText = settings.section.button_text || 'Learn More';
  const buttonStyle = settings.section.button_style || 'primary';
  const buttonUrl = settings.section.button_url || '#';
  const buttonAlignment = isMobile ? settings.section.button_alignment_mobile || 'center' : settings.section.button_alignment_desktop || 'left';
  
  // Minimum section height for CLS
  const minHeight = isMobile ? settings.section.mobile_min_height || 0 : settings.section.desktop_min_height || 0;

  return (
    <div 
      className={`circle-text-section w-full`}
      style={{ 
        minHeight: minHeight > 0 ? `${minHeight}px` : 'auto'
        // padding: isMobile 
        //   ? `${contentPadding.mobile.top}px ${contentPadding.mobile.right}px ${contentPadding.mobile.bottom}px ${contentPadding.mobile.left}px`
        //   : `${contentPadding.desktop.top}px ${contentPadding.desktop.right}px ${contentPadding.desktop.bottom}px ${contentPadding.desktop.left}px`
      }}
    >
      <div className={`flex flex-col lg:flex-row items-center gap-8 ${settings.section.content_alignment || 'items-center'}`}>
        {/* Circle with title and tagline */}
        <div className="circle-container relative">
          {/* Pulse animation circles (conditional rendering) */}
          {usePulse && (
            <>
                <AnimatedPulse 
                    settings={{
                        ...globals.pulse_animation,
                        className: "absolute top-0 w-full h-full"
                    }}
                />
            </>
          )}

          {/* Main circle */}
          <div 
            className="circle relative rounded-full flex flex-col justify-center items-center z-10"
          
          >
            <div className={`circle-content p-6 flex flex-col items-center gap-${settings.section.circle_content_gap}`}>
              {settings.section.tagline && (
                <Paragraph
                  text={settings.section.tagline}
                  type={settings.section.tagline_style || 'font-light text-sm uppercase tracking-wider'}
                />
              )}
              
              {settings.section.title && (
                <Paragraph
                  text={settings.section.title}
                  type={settings.section.title_style || 'font-bold text-3xl text-center'}
                />
              )}
              
              {settings.section.circle_number && (
                <div className="circle-number">
                  <span className={settings.section.number_style || 'font-bold text-5xl'}>{settings.section.circle_number}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right side content */}
        <div className={`rich-text-content text-left flex-1 z-2 ${isMobile ? 'mt-8' : ''}`}>
          {settings.section.rich_text && (
            <Paragraph
              text={settings.section.rich_text}
              type={settings.section.rich_text_style || 'text-base'}
            />
          )}
          
          {showButton && (
            <div className={`mt-6 flex justify-${buttonAlignment}`}>
              <Button
                label={buttonText}
                style={buttonStyle}
                link={buttonUrl}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CircleTextSection;